<!--
  - SPDX-FileCopyrightText: 2018 Nextcloud contributors
  - SPDX-License-Identifier: AGPL-3.0-or-later
-->

<script setup lang="ts">
import PollGroupEditDlg from '../PollGroup/PollGroupEditDlg.vue'
</script>

<template>
	<PollGroupEditDlg />
</template>
